import { Footer } from '../../components/footer';
import TopUpLevelsModal from '../modals/topupLevels';
import { useNavigate } from 'react-router-dom';
import { useProfileDetails } from '../profile-details/api/profileapi';
import { useUserLevelHistory, useUserOverAllUpgradeBalance } from './api/upgradeApi';
import { useToast } from '../../hook/usetoast';
import { useModalContext } from '../../contexts/ModalContext';
import Loader from '../Loader/buttonLoad';


const UpgradeWallet = () => {
    const toast = useToast()
    const { topUpLevelsModal, setTopUpLevelsModal } = useModalContext()

    const navigate = useNavigate()
    const { data: userProfile, isLoading: profileLoading } = useProfileDetails()

    const { data: levelDetails, isLoading: levelLoading } = useUserLevelHistory()

    const { data: userTopUpBalance, isLoading: topupLoading } = useUserOverAllUpgradeBalance()

    const activeLevels = userProfile?.directMembers || 0;

    const completeActiveLevels = userProfile?.completedLevels || 0;
    const topUpModel = async () => {
        if (userProfile?.completedLevels === 19) {
            toast.success("Top Level Completed")
        } else {
            setTopUpLevelsModal(!topUpLevelsModal)
        }
    }
    const displayValue = userProfile?.zorothlevelStatus 
  ? (Number(userProfile?.completedLevels || 0) >= 19 
      ? 40 
      : (Number(userProfile?.completedLevels || 0) + 1) * 2)
  : 0;

    return (
        <>
            {(levelLoading || profileLoading || topupLoading) && <Loader />}

            <div className="mainContent">
                <div className="pageContent def-py-30">
                    <div className='container'>
                        <div className="d-flex g-10 flex-wrap justify-content-between mb-3 mb-md-0">
                            <div className="appPagetitle"><button className='btn btnBack' onClick={() => navigate('/dashboard')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button> Upgrade Wallet</div>
                            <button className='btn btn-primary px-4' disabled={sessionStorage.getItem('role') === 'adminView'} onClick={topUpModel}>Top-Up Level</button>
                        </div>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 p-lg-4">
                                    <div className="row align-items-center">
                                        <div className="col-lg-4">
                                            <div className='d-flex g-15 align-items-center mb-3 mb-lg-0'>
                                                <div className='masterWalletIcon animate__animated animate__pulse animate__infinite'>
                                                    <img src={require('../../assets/images/upgradeWalletImg.svg').default} alt='upgradeWalletImg' className='img-fluid animate__animated animate__pulse animate__infinite' />
                                                </div>
                                                <div>
                                                    <div className='fs-14 fw-400'>Wallet Balance</div>
                                                    <div className='fs-20 fw-600'>{userTopUpBalance?.available ? parseFloat(userTopUpBalance?.available).toFixed(3) : 0} <span className='fs-14 fw-400 text-white-60'>USDT</span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-8">
                                            <div className="row rightLevelcnt">
                                                <div className="col-md col-sm-6 mb-3 mb-md-0">
                                                    <div>
                                                        <div className='labelTxt'>Over All Reward</div>
                                                        <div className='labelVal'>{userTopUpBalance?.reward ? parseFloat(userTopUpBalance?.reward).toFixed(3) : 0} <span className='fs-14 fw-400 text-white-60'>USDT</span></div>
                                                    </div>
                                                </div>

                                                <div className="col-md col-sm-6 mb-3 mb-md-0">
                                                    <div>
                                                        <div className='labelTxt'>Upgrade Completion</div>
                                                        <div className='labelVal'>{displayValue} <span className='fs-14 fw-400 text-white-60'>USDT</span></div>
                                                    </div>
                                                </div>
                                                <div className="col-md col-sm-6 mb-3 mb-md-0">
                                                    <div>
                                                        <div className='labelTxt'>Missed Payout</div>
                                                        <div className='labelVal'>{userTopUpBalance?.adminPay ? parseFloat(userTopUpBalance?.adminPay).toFixed(3) : 0} <span className='fs-14 fw-400 text-white-60'>USDT</span></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-auto">
                                                    <button className='btn btn-primary px-4' onClick={() => navigate('/upgradewallet-history')}>History </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='card2Head'>Level</div>
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map((level) => {
                                    // Find the reward data where _id = level - 1
                                    const rewardData = levelDetails?.data?.find(item => Number(item._id) === level - 1);

                                    return (
                                        <div className="appcard mb-4 p-lg-4" key={level}>
                                            <div className="row align-items-center">
                                                <div className="col-lg-auto col-md-auto">
                                                    <div className="appDarkCard mb-3 mb-md-0">
                                                        <div className="levelbx">
                                                            <div>
                                                                <div className="levelnumber">
                                                                    {String(level).padStart(2, '0')} <span className="smTxt">Level</span>
                                                                </div>
                                                            </div>
                                                            <div className="activeBx">
                                                                <div className={`checkbx ${level <= activeLevels ? 'active' : ''}`}></div>
                                                                <div className="label">Referral</div>
                                                            </div>
                                                            <div className="activeBx">
                                                                <div className={`checkbx ${level - 1 <= completeActiveLevels && userProfile?.zorothlevelStatus ? 'active' : ''}`}></div>
                                                                <div className="label">Top Up</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg col-md">
                                                    <div className="d-flex g-15 flex-wrap justify-content-between rightLevelcnt">
                                                        <div className="flex-fill">
                                                            <div className="labelTxt">Received Amount</div>
                                                            <div className="labelVal">
                                                                {rewardData?.reward
                                                                    ? parseFloat(rewardData.reward).toFixed(3)
                                                                    : 0}{' '}
                                                                <span className="smTxt">USDT</span>
                                                            </div>
                                                        </div>
                                                        <div className="flex-fill">
                                                            <div className="labelTxt">Missing Amount</div>
                                                            <div className="labelVal">
                                                                {rewardData?.missingRewardAmount
                                                                    ? parseFloat(rewardData.missingRewardAmount).toFixed(3)
                                                                    : 0}{' '}
                                                                <span className="smTxt">USDT</span>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <button
                                                                className="btn btn-secondary btnview"
                                                                onClick={() => navigate(`/level-details/${level}`)}
                                                            >
                                                                View
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}




                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
            <TopUpLevelsModal modalOpen={topUpLevelsModal} modalClose={() => setTopUpLevelsModal(!topUpLevelsModal)} />
        </>
    )
}

export default UpgradeWallet;